// Helpers for ProductDetail.jsx — color-name → swatch resolver, and the
// small InfoPill used in the shipping/delivery accordion.
//
// COLOR_MAP intentionally stores raw hex codes (not theme tokens) because
// these are *product attribute* colors (red shirt, navy hoodie, etc.) —
// they are user-facing swatches, not part of the Kapio brand palette.

import { C } from "../../lib/theme";
import { Icon } from "../../components/Icon";

export const COLOR_MAP = {
  black:  C.charcoal,
  white:  C.white,
  grey:   "#9CA3AF",
  gray:   "#9CA3AF",
  silver: "#C0C0C0",
  red:    "#DC2626",
  maroon: C.redDk,
  pink:   "#EC4899",
  orange: "#F97316",
  yellow: "#FACC15",
  gold:   "#D4AF37",
  green:  C.hunter,
  olive:  "#556B2F",
  teal:   "#14B8A6",
  blue:   "#2563EB",
  navy:   "#1E3A8A",
  purple: "#8B5CF6",
  brown:  "#78350F",
  tan:    "#D2B48C",
  beige:  "#F5F5DC",
  cream:  C.cream,
};

/**
 * Best-effort color name → swatch hex. Unknown names fall back to neutral
 * grey so the button still shows a dot; the label tells the buyer which
 * color it is.
 */
export function colorSwatch(name) {
  if (typeof name !== "string") return "#9CA3AF";
  const key = name.trim().toLowerCase();
  if (COLOR_MAP[key]) return COLOR_MAP[key];
  for (const k of Object.keys(COLOR_MAP)) {
    if (key.includes(k)) return COLOR_MAP[k];
  }
  return "#9CA3AF";
}

/** Small icon + label + value pill, used in the shipping accordion. */
export function InfoPill({ icon, label, value }) {
  return (
    <div
      style={{
        display:      "flex",
        alignItems:   "center",
        gap:          10,
        padding:      10,
        background:   C.cream,
        borderRadius: 10,
      }}
    >
      <Icon name={icon} size={14} color={C.hunter} />
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize:      9.5,
            fontWeight:    800,
            color:         C.muted,
            textTransform: "uppercase",
            letterSpacing: 1,
          }}
        >
          {label}
        </div>
        <div
          style={{
            fontSize:     12,
            fontWeight:   700,
            color:        C.charcoal,
            overflow:     "hidden",
            textOverflow: "ellipsis",
            whiteSpace:   "nowrap",
          }}
        >
          {value}
        </div>
      </div>
    </div>
  );
}
